import { render } from "./GerarDocumento.vue?vue&type=template&id=503c6114&scoped=true"
import script from "./GerarDocumento.vue?vue&type=script&lang=js"
export * from "./GerarDocumento.vue?vue&type=script&lang=js"

import "./GerarDocumento.vue?vue&type=style&index=0&id=503c6114&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503c6114"]])

export default __exports__